import React, { useEffect } from "react";
import Lottie from "react-lottie";
import Success from "../assets/lotties/success.json";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import utilReducer from "../reducers/utilReducer";
import { Button } from "antd";

const SuccessView = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        utilReducer.commonReducer("CLEAN_ORDER", {});
    }, []);

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: Success,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <div>
            <SuccessBook className="container">
                <Lottie options={defaultOptions} height={250} width={250} />
                <h1>{t("success.title")}</h1>
                <p>{t("success.description")}</p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        onClick={() => props.goBack()}
                        style={{
                            width: "80%",
                            backgroundColor: "#007bff",
                            padding: "10px 30px",
                            borderRadius: "7px",
                            color: "#fff",
                            textAlign: "center",
                            marginTop: "15px",
                        }}
                    >
                        {t("general.button_back_menu")}
                    </Button>
                </div>
            </SuccessBook>
        </div>
    );
};

const SuccessBook = styled.div`
    margin-top: 30%;

    @media (min-width: 1000px) {
        margin-top: 10%;
        a {
            width: 40% !important;
        }
    }

    h1 {
        text-align: center;
        font-size: 1.4em;
        font-weight: 600;
        margin-bottom: 20px;
        margin-top: -15px;
    }

    p {
        text-align: center;
        font-size: 0.9em;
        padding: 0px 20px;
    }

    button{
        height: 50px
    }
`;

export default SuccessView;
